import React, { Fragment, useState, useEffect } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, Link } from "react-router-dom";
import "react-phone-input-2/lib/style.css";
import { toast } from "react-toastify";
import SpinnerLoader from "../../../Layout/SpinnerLoader";
import DatePicker from 'react-datepicker';
import Typeahead from "../../../CommonElements/TypeAhead";
import {
  Amount, Customer, Description, PaymentMethod, Reference, Save, addwalletMoney, AddDeduct, walletMoney,
} from "../../../Constant";
import { AddWallet, AddWalletRole, getCustomers, getCustomersRole, paymentMethod, paymentMethodRole } from "../../../CommonUrl";
import { useSelector } from "react-redux";
import { getClientUrlDataToken, postClientUrlWithToken } from "../../../Utils/restUtils";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Transparentspinner from "../../Common/Loader/Transparentspinner";
import CustomerDropdown from "../../Common/CustomerField/CustomerDropdown";

const schema = yup.object().shape({
  customer: yup.mixed().required().label('Customer'),
  addDeduct: yup.mixed().required().label('Add/Deduct'),
  amount: yup.string().required().label('Amount'),
  paymentmethod: yup.mixed().required().label('Payment Method'),
})

const WalletForm = () => {
  const { register, handleSubmit, control, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
  });

  const authState = useSelector((state) => state.auth);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [Payment, setPayment] = useState([]);
  const [billDate, setBillDate] = useState(new Date());

  const type = [
    { value: "add", label: "Add" },
    { value: "deduct", label: "Deduct" },

  ];

  const navigate = useNavigate();

  useEffect(() => {
    areaData();
  }, []);


  useEffect(() => {
    const inputElement = document.getElementById("amount");
    const preventScrollEvent = (event) => {
      event.preventDefault();
    };
    inputElement.addEventListener('wheel', preventScrollEvent);
    return () => {
      inputElement.removeEventListener('wheel', preventScrollEvent);
    };
  }, []);

  const handleChangeBillDate = date => {
    setBillDate(date);
  };

  const areaData = async () => {
    const Customers_api = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getCustomers : getCustomersRole);
    if (Customers_api.status === true) {
      const customermaped = Customers_api.data.map((items) => ({ value: items.id, label: items.name }))
      setCustomers(customermaped)
    } else if (data.status >= 400 && data.status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (data.status >= 500 && data.status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }

    const payment = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? paymentMethod : paymentMethodRole);
    if (payment.status === true) {
      const set_payment = payment.data.map((itemss) => ({ value: itemss.id, label: itemss.name }))
      setPayment(set_payment)
    } else if (data.status >= 400 && data.status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (data.status >= 500 && data.status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    const postRequest = {
      customer_id: data.customer.value,
      transaction_type: data.addDeduct.value,
      payment_method: data.paymentmethod.value,
      amount: data.amount,
      description: data.address,
      reference: data.message,

    };
    const addCustomerResponse = await postClientUrlWithToken(
      authState.apiUrl, authState.userRole === 1 ? AddWallet : AddWalletRole, postRequest
    );
    if (addCustomerResponse.status === 200) {
      if (addCustomerResponse.data.status === true) {
        toast.success(addCustomerResponse.data.message)
        navigate(`${process.env.PUBLIC_URL}/customers/wallet`);
      } else {
        toast.error(addCustomerResponse.data.message)

      }
    } else if (addCustomerResponse.status >= 400 && addCustomerResponse.status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (addCustomerResponse.status >= 500 && addCustomerResponse.status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }

    setLoading(false);
  };
  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <Breadcrumbs mainTitle={walletMoney} parent="Customers" title={walletMoney} />
      <Card>
        <CardHeader className="pb-0">
          <H3>{addwalletMoney}</H3>
        </CardHeader>
        <CardBody>
          <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
            <Row className="g-3 ">
              <CustomerDropdown control={control} errors={errors} />
              <Col md="6">
                <FormGroup className="mb-3">
                  <Label className="form-label" >Date <span className="requireStar">*</span></Label>
                  <Col xl='12' md="12" sm='12'>
                    <DatePicker
                      id="bill"
                      style={{ padding: '12px 100px' }}
                      className="form-control "
                      dateFormat="dd/MM/yyyy"
                      placeholderText="dd/mm/yyyy"
                      onChange={handleChangeBillDate}
                      // peekNextMonth
                      selected={billDate}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      required
                    />
                  </Col>

                </FormGroup>
              </Col>
            </Row>
            <Row className="g-3 pt-3">

              <Col md="6">
                <Label className="form-label" for="validationCustom02">{AddDeduct}  <span className="requireStar">*</span></Label>
                <Controller
                  name="addDeduct"
                  control={control}
                  render={({ field }) => (
                    <Typeahead
                      options={type}
                      onChange={(value) => {
                        field.onChange(value);
                      }}
                      value={field.value}
                    />
                  )}
                />
                <p className="text-danger">{errors.addDeduct?.message}</p>
              </Col>
              <Col md="6" >
                <Label className="form-label" for="validationCustom02">{Amount} <span className="requireStar">*</span></Label>
                <input className="form-control diableScroll" id="amount" type="number" min={0}
                  {...register("amount", { required: true })}
                />
                <p className="text-danger">{errors.amount?.message}</p>
              </Col>
            </Row>
            <Row className="g-3 pt-3">
            </Row>
            <Row className="g-3 pt-3">
              <Col md="6">
                <Label className="form-label" for="validationCustom02">{PaymentMethod} <span className="requireStar">*</span></Label>
                <Controller
                  name="paymentmethod"
                  control={control}
                  render={({ field }) => (
                    <Typeahead
                      options={Payment}
                      onChange={(value) => {
                        field.onChange(value);
                      }}
                      value={field.value}
                    />
                  )}
                />
                <p className="text-danger">{errors.paymentmethod?.message}</p>
              </Col>
              <Col>
                <Label className="form-label pt-1">{Reference}</Label>
                <Controller
                  name="address"
                  control={control}
                  render={({ field }) => (
                    <input className="form-control" {...field} rows="4" />
                  )}
                />
              </Col>
            </Row>
            <Row className="g-3 pb-3">
              <Col md='6'>
                <Label className="form-label pt-3">{Description}</Label>
                <Controller
                  name="message"
                  control={control}
                  render={({ field }) => (
                    <textarea className="form-control" {...field} rows="3" />
                  )}
                />
              </Col>
              {/* <Col>
                <Label className="form-label pt-3">Attachment</Label>
                <Controller
                  name="attachment"
                  control={control}
                  render={({ field }) => (
                    <input
                      type="file"
                      className="form-control"
                      {...field}
                    />
                  )}
                />
              </Col> */}
            </Row>
            <Row className="g-3">
            </Row>
            <FormGroup></FormGroup>
            <div className="d-flex justify-content-center mt-3 gap-2">
              <Btn attrBtn={{ color: "primary" }} type="submit">{Save}</Btn>
              <Link to="/customers/wallet" className="btn btn-light" type="button">
                Cancel
              </Link>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Fragment>
  );
};
export default WalletForm;
